/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Access_Permissions_LabelInputs */

const en_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Permissions`)
};

const fr_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations d’accès`)
};

const de_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriffsberechtigungen`)
};

const it_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizzazioni di accesso`)
};

const ru_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Права доступа`)
};

const es_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos de acceso`)
};

const zh_cn2_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问权限`)
};

const ja_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセス権限`)
};

const hi_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहुँच अनुमतियाँ`)
};

const pt_pt2_knp_guide_access_permissions_label = /** @type {(inputs: Knp_Guide_Access_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões de acesso`)
};

/**
* | output |
* | --- |
* | "Access Permissions" |
*
* @param {Knp_Guide_Access_Permissions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_access_permissions_label = /** @type {((inputs?: Knp_Guide_Access_Permissions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Access_Permissions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_access_permissions_label(inputs)
	if (locale === "de") return de_knp_guide_access_permissions_label(inputs)
	if (locale === "it") return it_knp_guide_access_permissions_label(inputs)
	if (locale === "ru") return ru_knp_guide_access_permissions_label(inputs)
	if (locale === "es") return es_knp_guide_access_permissions_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_access_permissions_label(inputs)
	if (locale === "ja") return ja_knp_guide_access_permissions_label(inputs)
	if (locale === "hi") return hi_knp_guide_access_permissions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_access_permissions_label(inputs)
	return en_knp_guide_access_permissions_label(inputs)
});